import React from 'react';
import {
    Switch, Select, Divider, Input, Col, Row, Checkbox, Modal, Button, Form, Table, TreeSelect, Space, Card, Tabs, Collapse
} from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet, requestWarroomServerGet } from '../../actions';
import PlaylistTableView from '../views/PlaylistTableView';
import Column from 'antd/lib/table/Column';
import ActionButton from '../ActionButton';
import "./PlaylistSelectorPopup.css";
import PopupManager from '../../managers/PopupManager';
import Colors from '../../config/Colors';
import { CloseOutlined, CheckOutlined, CrownTwoTone } from '@ant-design/icons';
import { ShieldCheck, Plus } from 'lucide-react';
import PermissionManager from '../../managers/PermissionManager';
import { SP } from 'next/dist/next-server/lib/utils';
import RolesPermissions from '../views/RolesPermissions';
import PermissionMatrix from '../views/PermissionMatrix';
import { ALL_PERMISSION_PAGES } from '../../Config';
import DataHelper from '../../helpers/DataHelper';


const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;
// const SCALE_TYPES = ["fill", "contain", "cover", "none", "scale-down"]
const SCALE_TYPES = ["fill", "contain", "cover", "none"]
const SCALE_TYPE_DESCRIPTIONS = ["Media is sized to fill the channel's boundary", "Media is scaled to maintain its aspect ratio while fitting within the channel's boundary", "Media is sized to maintain its aspect ratio while filling the channel's boundary. The media will be clipped to fit", "Media is not resized"]

const allowEdit = true;
const allowDelete = true;

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
    colon: true
};

const options = [
    { label: 'View', value: 'View' },
    { label: 'Create', value: 'Create' },
    { label: 'Update', value: 'Update' },
    { label: 'Delete', value: 'Delete' },
];


class RolePanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = { data: null, settings: "", currentSettings: "" };
    }

    componentDidMount() {


        this.setState({ data: this.props.data, settings: this.props.data.UserRolePermission, currentSettings: this.props.data.UserRolePermission });
    }
    componentDidUpdate(prevPrpos) {
        // console.log("props updated " + JSON.stringify(this.props))
        if (prevPrpos.data !== this.props.data) {
            this.setState({ data: this.props.data, settings: this.props.data.UserRolePermission, currentSettings: this.props.data.UserRolePermission });
        }
    }

    getPermissionDitgitsString = (arr) => {
        const permissions = ["View", "Create", "Update", "Delete"];

        if (permissions.every(pName => {
            return arr.includes(pName);
        })) {
            return "1";
        }

        if (arr.length === 0) {
            return "0";
        }

        var result = [];

        permissions.forEach(pName => {
            result.push(arr.includes(pName) ? 1 : 0);
        })

        return result.join("");
    }

    handleChange = (roleData, key, permissionsArray) => {

        const cSetting = { ...this.state.currentSettings }
        cSetting[key] = this.getPermissionDitgitsString(permissionsArray)

        this.setState({ currentSettings: cSetting })
        // var update = [...this.state.changedPermissions]

        // update = update.map(u => {
        //     if(u.UserRoleID === roleData.UserRoleID)
        //     {
        //         return {UserRoleID:roleData.UserRoleID, UserRoleName:roleData.UserRoleName, UserRolePermission}
        //     }
        // })
    }

    updateUserRole = () => {

        const { onRoleNeedsUpdate = () => { } } = this.props
        onRoleNeedsUpdate(this.state.currentSettings);

    }

    render() {


        if (!this.state.data) {
            return null;
        }

        const rDat = this.state.data;

        const sectionPermissionkeys = Object.keys(rDat.UserRolePermission).filter((key) => {
            return key !== PermissionManager.PERMISSION_KEY_PUBLISH && key !== PermissionManager.PERMISSION_KEY_ASSIGNSCREEN;
        })
        const abilityPermissionkeys = Object.keys(rDat.UserRolePermission).filter((key) => {
            return key === PermissionManager.PERMISSION_KEY_PUBLISH || key === PermissionManager.PERMISSION_KEY_ASSIGNSCREEN;
        })

        const currentSameWithSaved = Object.keys(this.state.currentSettings).every(k => {
            const currentP = this.state.currentSettings[k]
            const savedP = this.state.settings[k]
            if (currentP === savedP) {
                return true;
            }
            else {


                const allOneRegex = /^(1)\1*$/g;
                const allZeroRegex = /^(1)\1*$/g;


                if (allOneRegex.test(currentP) && allOneRegex.test(savedP))
                    return true;

                if (allZeroRegex.test(currentP) && allZeroRegex.test(savedP))
                    return true;


                return (currentP === savedP)
            }
        })
        return (

            <div style={{ marginBottom: "20px", width: "100%" }}>
                <Space direction="vertical" style={{ marginRight: "40px", width: "100%" }}>

                    {/* {rDat.UserRoleName.toLocaleUpperCase()} */}
                    {
                        <Card style={{ width: "100%" }}>

                            <Tabs defaultActiveKey="1" onChange={() => { }} style={{ width: "100%" }}>

                                <TabPane tab="PAGE PERMISSIONS" key="1" style={{ width: "100%" }}>

                                    {/* <Space direction="horizontal" size="small" style={{ display: "flex" }}> */}
                                    <div style={{ display: "block", flexDirection: "column", justifyContent: "center" }}>
                                        <div style={{ display: "flex", width: "100%", flexWrap: "wrap", justifyContent: "center" }}>
                                            {sectionPermissionkeys.map(k => {

                                                const value = rDat.UserRolePermission[k];
                                                var selections = []
                                                if (`${value}` === `1`) {
                                                    selections = ["View", "Create", "Update", "Delete"];
                                                }
                                                else if (value.length === 4) {
                                                    if (`${value.charAt(0)}` === `1`) {
                                                        selections.push("View")
                                                    }
                                                    if (`${value.charAt(1)}` === `1`) {
                                                        selections.push("Create")
                                                    }
                                                    if (`${value.charAt(2)}` === `1`) {
                                                        selections.push("Update")
                                                    }
                                                    if (`${value.charAt(3)}` === `1`) {
                                                        selections.push("Delete")
                                                    }
                                                }

                                                return (

                                                    <div key={k} style={{ width: "80px", display: "inline-block", margin: "5px" }}>
                                                        <Space direction="vertical">
                                                            <span style={{ fontWeight: 600 }}>{k.toLocaleUpperCase()}</span>
                                                            <Checkbox.Group options={options} style={{ display: "block" }} defaultValue={selections} onChange={(change) => {
                                                                this.handleChange(rDat, k, change)
                                                            }} />
                                                        </Space>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    {/* </Space> */}

                                </TabPane>
                                <TabPane tab="OTHER PERMISSIONS" key="2">

                                    <Space direction="vertical" size="small">

                                        {abilityPermissionkeys.map(k => {

                                            const value = rDat.UserRolePermission[k];
                                            var selections = []
                                            var checked = false;

                                            if (`${value}` === `1` || `${value}` === `1111`) {
                                                checked = true;
                                            }
                                            // if (`${value}` === `1`) {
                                            //     selections = ["View", "Create", "Update", "Delete"];
                                            // }
                                            // else if (value.length === 4) {
                                            //     if (`${value.charAt(0)}` === `1`) {
                                            //         selections.push("View")
                                            //     }
                                            //     if (`${value.charAt(1)}` === `1`) {
                                            //         selections.push("Create")
                                            //     }
                                            //     if (`${value.charAt(2)}` === `1`) {
                                            //         selections.push("Update")
                                            //     }
                                            //     if (`${value.charAt(3)}` === `1`) {
                                            //         selections.push("Delete")
                                            //     }
                                            // }


                                            const allOneRegex = /^(1)\1*$/g;

                                            console.log("this.state.currentSettings " + JSON.stringify(this.state.currentSettings) + " " + k)
                                            const isChecked = allOneRegex.test(this.state.currentSettings[k]);

                                            return (

                                                <div key={k} style={{ width: "100px" }}>
                                                    <Space direction="horizontal">
                                                        <Checkbox checked={isChecked} onChange={(checkevent) => {


                                                            const cSetting = { ...this.state.currentSettings }
                                                            cSetting[k] = checkevent.target.checked ? "1" : "0"

                                                            this.setState({ currentSettings: cSetting });
                                                        }}></Checkbox>
                                                        <span style={{ fontWeight: 600 }}>{k.toLocaleUpperCase()}</span>
                                                        {/* <Checkbox.Group options={options} style={{}} defaultValue={selections} onChange={(change) => {
                                                            console.log(change)
                                                            this.handleChange(rDat, k, change)
                                                        }} /> */}
                                                    </Space>
                                                </div>
                                            )
                                        })}
                                    </Space>

                                </TabPane>
                            </Tabs>
                            <Button disabled={currentSameWithSaved} onClick={this.updateUserRole} style={{ alignSelf: "flex-end", margin: "10px 30px", float: "right", width: "100px" }} type="primary">Save</Button>

                        </Card>

                    }
                </Space>
            </div>
        )
    }
}

class RoleManagementPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            roleDatas: [],
            changedPermissions: [],
            isCreateModalVisible: false,
            newRoleName: "",
            newRoleDescription: "",
            subscriptionPlans: [],
            userSubscriptionPlan: null,
            newRole: null, // 👈 stores temporary new role with permissions
        };
    }

    // buildRolePermissions = (roleData, isEditMode = false) => {
    //     const existingPermissions = roleData.userrolepermissions || {};

    //     // Always use full list in edit mode
    //     const sourcePages = isEditMode ? ALL_PAGES : Object.keys(existingPermissions);

    //     return sourcePages.map(page => {
    //         const pagePerm = existingPermissions[page] || {};
    //         return {
    //             id: page,
    //             name: page,
    //             canRead: !!pagePerm.canRead,
    //             canCreate: !!pagePerm.canCreate,
    //             canUpdate: !!pagePerm.canUpdate,
    //             canDelete: !!pagePerm.canDelete,
    //             canPublish: !!pagePerm.canPublish,
    //             canUpload: !!pagePerm.canUpload,
    //         };
    //     });
    // };

    getEmptyRoleTemplate = () => {


        return {
            id: 0,
            name: "",
            description: "",
            permissions: ALL_PERMISSION_PAGES.map((page) => ({
                id: page,
                name: page,
                canRead: false,
                canCreate: false,
                canUpdate: false,
                canDelete: false,
                canPublish: false,
                canUpload: false,
            })),
        };
    };



    componentDidMount() {
        // const "get_userroles"
        this.reloadUserRoles();
        this.reloadSubscriptionPlans().then(this.selectUserCurrentPlan);
    }

    reloadUserRoles = () => {
        const { usermaintoken, requestServerGet } = this.props;

        // requestServerGet("get_userroles", {}, null, (response) => {

        //     const datas = response.data.map(dat => {

        //         return { UserRoleID: dat.UserRoleID, UserRoleName: dat.UserRoleName, UserRolePermission: JSON.parse(dat.UserRolePermission) ?? {}, UserRolePermissionString: dat.UserRolePermission }
        //     })
        //     this.setState({ roleDatas: datas })


        // }, usertoken)

        requestServerGet("get_optionrole", {}, null, (response) => {
            // console.log(response.data)
            // const options = response.data.map(data => {
            //     return { value: data.CampaignID, label: data.CampaignName }
            // })

            const processedRoles = response.data.map((roleData, index) => {
                return {
                    userroleid: roleData.userroleid,
                    userrolename: roleData.userrolename,
                    userrolepermissions: roleData.rolepermission
                    // key: userData.userid,
                    // name: `${userData.firstname} ${userData.lastname}`,
                    // role: userData.userrolename,
                    // status: userData.activated.toLocaleLowerCase() === "y" ? 1 : 0,
                }
            })
            // options.unshift({ value: 0, label: "Create New Playlist" })
            this.setState({ roleDatas: processedRoles })
            console.log("roleDatas " + JSON.stringify(processedRoles))
            // this.setState({ campaigntDatas: options, campaignOptions: options })
        }, usermaintoken)
    }

    selectUserCurrentPlan = () => {
        const { userdata } = this.props;

        console.log("selectUserCurrentPlan " + JSON.stringify(userdata));

        if ("user" in userdata && "planid" in userdata.user) {
            const currentPlan = this.state.subscriptionPlans.find((plan) => plan.planid === userdata.user.planid);
            this.setState({ userSubscriptionPlan: currentPlan});
        }

    }

    reloadSubscriptionPlans = () => {
        return new Promise((resolve, reject) => {
            const { usertoken, requestWarroomServerGet, selectedBrandData } = this.props;

            requestWarroomServerGet("get_subscriptionplans", {}, null, (response) => {

                if (!response) {
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                const responseData = response.data;
                console.log("reloadSubscriptionPlans " + JSON.stringify(responseData.data))
                if (!responseData || !responseData.success) {
                    console.log("reloadSubscriptionPlans no responseData")
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                if (!responseData.data || responseData.data.length === 0) {
                    console.log("reloadSubscriptionPlans no data")
                    this.setState({ subscriptionPlans: [] }, resolve)
                    return;
                }

                this.setState({ subscriptionPlans: responseData.data }, resolve)
                // const processedRoles = response.data.map((roleData, index) => {
                //     return {
                //         userroleid: roleData.userroleid,
                //         userrolename: roleData.userrolename,
                //         userrolepermissions: roleData.Permissions
                //     }
                // })

                // this.setState({ roles: processedRoles }, resolve)
                resolve();
            }, usertoken)
        })

    }

    updateUserRole = (userRoleData, newPermissions) => {


        const { requestServerPost, usermaintoken } = this.props
        const params = new FormData();


        params.append("userroleid", userRoleData.UserRoleID)
        // params.append("userrolename", this.state.rDat.UserRoleName)
        params.append("userrolepermission", JSON.stringify(newPermissions))

        console.log("updateUserRole " + JSON.stringify(newPermissions))

        return;

        // const { onRoleSaved = () => { } } = this.props;


        // requestServerPost("update_userrole", params, { }, (response) => {
        //     Modal.success({ content: `Successfully updated the user role ${userRoleData.UserRoleName}`, onOk: () => { console.log("modal closed"); } })
        //     this.reloadUserRoles();
        // }, usermaintoken);
    }

    handleCreateRole = () => {
        const { newRoleName, newRoleDescription, newRole } = this.state;
        const { requestServerPost, usermaintoken } = this.props;

        if (!newRoleName.trim()) {
            Modal.warning({ content: "Please enter a role name before saving." });
            return;
        }

        // Convert array → object format, including only pages with at least one true
        const rolePermissionObject = {};
        newRole.permissions.forEach((p) => {
            const hasAnyTrue =
                p.canRead ||
                p.canCreate ||
                p.canUpdate ||
                p.canDelete ||
                p.canPublish ||
                p.canUpload;

            if (hasAnyTrue) {
                rolePermissionObject[p.id] = {
                    canRead: p.canRead,
                    canCreate: p.canCreate,
                    canUpdate: p.canUpdate,
                    canDelete: p.canDelete,
                    canPublish: p.canPublish,
                    canUpload: p.canUpload,
                };
            }
        });

        const payload = JSON.stringify({
            roleid: 0,
            rolename: newRoleName,
            roledescription: newRoleDescription,
            rolepermission: rolePermissionObject,
        });

        if (Object.keys(rolePermissionObject).length === 0) {
            Modal.warning({
                content: "Please enable at least one permission before creating this role.",
            });
            return;
        }

        requestServerPost(
            "create_role",
            payload,
            { "Content-Type": "application/json" },
            (response) => {
                Modal.success({
                    content: `Successfully created new role "${newRoleName}"`,
                    onOk: () => {
                        this.setState({
                            isCreateModalVisible: false,
                            newRoleName: "",
                            newRoleDescription: "",
                            newRole: null,
                        });
                        this.reloadUserRoles();
                    },
                });
            },
            usermaintoken
        );
    };



    toggleNewRolePermission = (recordId, action) => {
        this.setState((prevState) => {
            const updatedRole = {
                ...prevState.newRole,
                permissions: prevState.newRole.permissions.map((p) =>
                    p.id === recordId ? { ...p, [action]: !p[action] } : p
                ),
            };
            return { newRole: updatedRole };
        });
    };


    render() {
        const { userdata } = this.props;
        const editPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_ROLE, PermissionManager.PERMISSION_TYPE_EDIT);
        const createPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_ROLE, PermissionManager.PERMISSION_TYPE_CREATE);
        const bleed = { margin: -24, overflow: 'hidden' };

        return (
            <div>
                {/* Gradient header — bleed edge-to-edge */}
                <div style={{ ...bleed, marginBottom: 0, background: 'linear-gradient(135deg,#6366f1,#4f46e5)', padding: '28px 40px 24px', textAlign: 'center', color: '#fff' }}>
                    <div style={{ width: 52, height: 52, borderRadius: 14, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                        <ShieldCheck size={26} color="#fff" />
                    </div>
                    <div style={{ fontSize: 20, fontWeight: 700 }}>Roles &amp; Permissions</div>
                    <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.8)', marginTop: 4 }}>Manage access control for your team</div>
                </div>

                {/* Body */}
                <div style={{ paddingTop: 20 }}>
                    {createPermission && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 14 }}>
                            <button
                                onClick={() => this.setState({ isCreateModalVisible: true, newRoleName: '', newRoleDescription: '', newRole: this.getEmptyRoleTemplate() })}
                                style={{ height: 38, padding: '0 18px', borderRadius: 8, background: 'linear-gradient(135deg,#6366f1,#4f46e5)', color: '#fff', border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}
                            >
                                <Plus size={15} color="#fff" /> Create New Role
                            </button>
                        </div>
                    )}
                    <RolesPermissions allowEdit={editPermission} data={this.state.roleDatas} parentProps={this.props} reloadUserRoles={this.reloadUserRoles} planData={this.state.userSubscriptionPlan} />
                </div>

                {/* Create Role inner modal */}
                <Modal
                    title={null}
                    open={this.state.isCreateModalVisible}
                    onCancel={() => this.setState({ isCreateModalVisible: false })}
                    footer={null}
                    centered
                    width={900}
                >
                    <div style={{ margin: -24, overflow: 'hidden', marginBottom: 0 }}>
                        <div style={{ background: 'linear-gradient(135deg,#6366f1,#4f46e5)', padding: '22px 32px 20px', color: '#fff' }}>
                            <div style={{ fontSize: 17, fontWeight: 700 }}>Create New Role</div>
                            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.8)', marginTop: 3 }}>Define page and action permissions for this role</div>
                        </div>
                    </div>
                    <div style={{ paddingTop: 24 }}>
                        <div style={{ marginBottom: 20 }}>
                            <label style={{ fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 6 }}>Role Name</label>
                            <Input
                                placeholder="Enter role name"
                                value={this.state.newRoleName}
                                onChange={(e) => this.setState({ newRoleName: e.target.value })}
                                style={{ borderRadius: 8, height: 40 }}
                            />
                        </div>
                        {this.state.newRole && (
                            <PermissionMatrix
                                role={{ ...this.state.newRole, name: this.state.newRoleName || 'New Role' }}
                                isReadOnly={false}
                                togglePermission={(roleId, recordId, action) =>
                                    this.toggleNewRolePermission(recordId, action)
                                }
                                isPermissionLocked={(menuName, action) => {
                                    if (this.state.userSubscriptionPlan && 'permissions' in this.state.userSubscriptionPlan) {
                                        const planPermissions = this.state.userSubscriptionPlan.permissions;
                                        if (menuName in planPermissions) {
                                            const perm = planPermissions[menuName];
                                            const result = DataHelper.getCaseInsensitiveFromObject(perm, action);
                                            if (result !== undefined) return result <= 0;
                                            return false;
                                        }
                                        return false;
                                    }
                                    return false;
                                }}
                                getActionLabel={(a) => ({ canRead: 'View', canCreate: 'Create', canUpdate: 'Edit', canDelete: 'Delete', canPublish: 'Publish', canUpload: 'Upload' }[a] || a)}
                            />
                        )}
                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24, paddingTop: 16, borderTop: '1px solid #f1f5f9' }}>
                            <button
                                onClick={() => this.setState({ isCreateModalVisible: false })}
                                style={{ height: 40, padding: '0 20px', borderRadius: 8, background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={this.handleCreateRole}
                                style={{ height: 40, padding: '0 24px', borderRadius: 8, background: 'linear-gradient(135deg,#6366f1,#4f46e5)', color: '#fff', border: 'none', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
                            >
                                Create Role
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, usermaintoken: state.usermaintoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}
export default connect(mapStateToProps, { requestServerGet, requestWarroomServerGet, requestServerPost, selectPage, requestNodeServerPost })(RoleManagementPopup);